import templateUrl from 'emun.invoice/return-item-prompt.htm'
import controller from 'emun.invoice/return-item-prompt.controller'
import modals from 'webmodals/modals'

export default options => modals.open(Object.assign({
    size: 'sm',
    templateUrl,
    background: 'static',
    resolve: {
        options: () => options
    },
    bindToController: true,
    controller,
    controllerAs: '$ctrl'
}, (options || {}).modal)).result;